<template>
  <div class="app-grid" :class="computedGridStyle">
    <template v-if="isLoading">
      <slot name="loading">
        <app-grid-item is-loading />
      </slot>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  name: 'AppGrid',
  props: {
    isLoading: {
      type: Boolean as PropType<boolean>,
    },
    itemsCount: {
      type: Number as PropType<number>,
      default: 0,
    },
  },
  computed: {
    computedGridStyle(): string {
      if (this.isLoading) return 'app-grid--items-count-1'
      
      if (this.itemsCount === 0) return ''

      return `app-grid--items-count-${this.itemsCount}`
    },
  },
})
</script>

<style lang="scss" scoped>
.app-grid {
  $grid-gap: 16px;
  $grid-item-min-width: 368px;
  $grid-fixed-items-count: 2;

  display: grid;
  gap: $grid-gap;
  grid-template-columns: repeat(auto-fit, minmax($grid-item-min-width, 1fr));

  @for $i from 1 through $grid-fixed-items-count {
    &--items-count-#{$i} {
      max-width: ($grid-item-min-width * $i) + ($grid-gap * ($i - 1));
    }
  }
}
</style>